import { render, staticRenderFns } from "./UpdateShare.vue?vue&type=template&id=26123bcb"
import script from "./UpdateShare.vue?vue&type=script&lang=js"
export * from "./UpdateShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports